<template>
  <div class="meeting-agenda">
    <div class="page-header-banner">
      <div class="banner-main-content">
        <h1>大会嘉宾</h1>
        <p>CONFERENCE GUESTS</p>
        <p>2021/12/01 - 2021/12/03</p>
      </div>
    </div>
    <div class="agenda-list">
      <div class="common-guests main-forum-guests">
        <div class="main-title">
          <div class="first-item"></div>
          <div>
            <span style="letter-spacing:25px;">重磅嘉宾</span>
            <span style="letter-spacing:0;">HONOURED GUESTS</span>
          </div>
        </div>
        <div class="main-guests">
          <!-- <span class="iconfont icon-ios-arrow-back"></span> -->
          <swiper ref="swiper" :options="swiperOption">
            <swiperSlide
              v-for="(item, index) in mainGuests"
              :key="'mainGuests' + index"
            >
              <div
                class="guests-item"
                :style="{
                  backgroundImage:
                    'url(' +
                    item.img +
                    ')' +
                    ',linear-gradient(177deg, rgba(255, 255, 255, 0) 0%, rgba(237, 240, 244, 1) 88%)'
                }"
              >
                <div class="cover-class"></div>
                <div class="guests-info">
                  <div class="guests-name">{{ item.name }}</div>
                  <div class="guests-position">{{ item.company }}</div>
                  <div class="guests-position">{{ item.position }}</div>
                </div>
              </div>
            </swiperSlide>
          </swiper>
          <!-- <span class="iconfont icon-ios-arrow-forward"></span> -->
        </div>
      </div>
    </div>
    <div class="agenda-white-background">
      <div class="white-bg-content">
        <div class="common-guests sub-forum-guests">
          <div class="main-title">
            <div class="forum-icon"></div>
            <div>
              <span>论坛嘉宾</span>
              <span class="forum-guests">FORUM GUESTS</span>
            </div>
          </div>
          <div class="sub-guests">
            <div
              v-for="(item, indexG) in guestsList"
              :key="indexG"
              class="li_list"
            >
              <div class="sub-has-bg"></div>
              <div class="sub-guests-info">
                <span></span>
                <div class="sub-guests-name">{{ item.name }}</div>
                <div class="sub-guests-position">{{ item.company }}</div>
                <div class="sub-guests-position">{{ item.position }}</div>
              </div>
              <img :src="item.img" alt />
              <div class="sub-forum-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Swiper, swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
      guestsList: [],
      mainGuests: [],
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        autoplay: 1300,
        loop: true
      }
    };
  },

  components: { swiper, swiperSlide },

  computed: {},
  mounted() {
    this.getForumGuests();
  },

  methods: {
    //从cms上获取嘉宾信息
    getForumGuests() {
      // 论坛嘉宾
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/forumGuests.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.guestsList = res.data;
      });
      // 重磅嘉宾
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/mainGuests.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.mainGuests = (res.data || []).map(item => {
          item.img =
            "/r/cms/www/itn/images/deveConfere/pcMainGuests/" +
            item.img2 +
            ".png";
          return item;
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.meeting-agenda {
  background: #fff;
  .page-header-banner {
    width: 100%;
    min-width: 1200px;
    height: 465px;
    background: url("../../../assets/developerConference/agenda_banner-big.jpg")
      no-repeat center;
    // background-size: 3500px 465px;
    background-size: cover;
    color: #ffffff;
    .banner-main-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 44px;
        padding-top: 159px;
        color: #333333;
        line-height: 54px;
        font-weight: 700;
      }
      p {
        font-family: MicrosoftYaHei-Bold;
        font-size: 28px;
        color: #ffffff;
        color: #000000;
        text-align: left;
        &:last-of-type {
          font-family: MicrosoftYaHei;
          font-size: 22px;
          opacity: 0.8;
          padding-top: 5px;
        }
      }
    }
  }
  @media screen and (max-width: 1366px) {
    .page-header-banner {
      height: 399px;
      background: url("../../../assets/developerConference/agenda_banner-small.jpg")
        no-repeat center;
    }
  }
  .agenda-list {
    margin: 0 auto;
    padding-top: 64px;
    width: 1200px;
    min-width: 1200 xp;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
    overflow: hidden;
  }

  .agenda-white-background {
    padding-top: 64px;
    background: url("../../../assets/developerConference/guestsBack.jpg")
      no-repeat center;
    background-size: 100% 100%;
    padding-bottom: 88px;
    width: 100%;
    overflow: hidden;

    .white-bg-content {
      margin: 0 auto;
      width: 1200px;
      min-width: 1200 xp;
    }
  }

  .common-guests {
    .main-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      font-family: MicrosoftYaHei;
      padding-bottom: 43px;

      > div:nth-child(1) {
        background-size: cover;
        width: 100px;
        height: 100px;
      }

      > div:nth-child(2) {
        display: flex;
        flex-direction: column;
        span:nth-child(1) {
          font-size: 28px;
          font-weight: 700;
          letter-spacing: 25px;
        }
        span:nth-child(2) {
          font-size: 20px;
          color: rgba($color: #333, $alpha: 0.53);
        }
        .forum-guests {
          letter-spacing: 3px;
        }
      }

      > div:nth-child(3) {
        color: #333333;
        font-family: ArialMT;
      }
      .first-item {
        background: url("../../../assets/developerConference/heavy-icon.png");
        margin-right: 23px;
      }
      .forum-icon {
        background: url("../../../assets/developerConference/forum-guests-icon.png");
        margin-right: 23px;
      }
    }
  }

  .main-forum-guests {
    margin-bottom: 60px;

    .main-guests {
      .guests-item {
        min-width: 188px;
        height: 282px;
        margin: 10px 17px;
        background-image: linear-gradient(180deg, #ffffff 0%, #000 88%);
        box-shadow: 8px 0 16px rgba(217, 217, 217, 0.4);
        border: 1px solid #d2dbe8;
        border-radius: 3px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ffffff;
        line-height: 25px;
        position: relative;
        background-repeat: no-repeat;
        background-position: bottom center;
        background-size: 100% auto;
        &:last-child {
          margin-right: 0;
        }
        .cover-class {
          position: absolute;
          width: 100%;
          height: 120px;
          bottom: 0;
          background-image: linear-gradient(
            177deg,
            rgba(65, 110, 190, 0) 25%,
            rgba(0, 0, 0, 0.87) 100%
          );
        }
        .guests-info {
          position: absolute;
          bottom: 10px;
          margin: 0 22px;
          line-height: 20px;

          .guests-name {
            font-family: MicrosoftYaHei-Bold;
            font-size: 22px;
            padding-bottom: 6px;
          }
          .guests-position {
            font-size: 12px;
          }
        }

        .guests-detail-info {
          width: 100%;
          height: 100%;
          opacity: 0.86;
          background: #333333;
          padding: 51px 24px 37px;
          line-height: 25px;
          word-break: break-all;
          display: none;
        }

        &:hover {
          .guests-detail-info {
            display: block;
          }
        }
      }
    }
  }

  .sub-forum-guests {
    .sub-guests {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      & > div {
        width: 380px;
        height: 200px;
        background: #ffffff;
        border: 1px solid #d2dbe8;
        border-radius: 3px;
        position: relative;
        margin-right: 30px;
        margin-bottom: 30px;

        &:nth-child(n) {
          .sub-guests-info {
            > span {
              display: block;
              width: 19px;
              height: 4px;
              background: url("../../../assets/developerConference/line-top.png")
                no-repeat center;
              background-size: 100% 100%;
              margin-bottom: 7px;
            }
          }
        }

        &:nth-child(3n-1) {
          .sub-guests-info {
            > span {
              display: block;
              width: 19px;
              height: 4px;
              background: url("../../../assets/developerConference/line-top.png")
                no-repeat center;
              background-size: 100% 100%;
              margin-bottom: 7px;
            }
          }
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:after {
          display: block;
          content: "";
          width: 378px;
          height: 4px;
          transform: scaleX(-1), rotate(180deg);
          background: url("../../../assets/developerConference/line-bottom.png")
            no-repeat center;
          background-size: 100% 100%;
          position: absolute;
          bottom: 50px;
          left: 0px;
        }

        .sub-has-bg {
          width: 380px;
          height: 149px;
          opacity: 0.29;
          background: #fff;
          border-radius: 3px 3px 0 0;
        }

        .sub-guests-info {
          position: absolute;
          top: 33px;
          left: 27px;
          width: 215px;

          .sub-guests-name {
            font-family: MicrosoftYaHei-Bold;
            font-size: 20px;
            color: #333333;
            font-weight: 700;
          }

          .sub-guests-position {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #666666;
          }
        }

        img {
          width: 140px;
          // height: 197px;
          position: absolute;
          bottom: 52px;
          right: 13px;
        }

        .sub-forum-title {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #333333;
          padding-top: 13px;
          overflow: hidden;
          white-space: nowrap;
          width: 100%;
          display: inline-block;
          text-overflow: ellipsis;
          padding-left: 23px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/guests.vue